var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDebtCollectionClaims(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.61816 10.3311H6.36523C7.06348 10.3311 7.58594 10.1943 7.93262 9.9209C8.2793 9.64258 8.45264 9.23975 8.45264 8.7124C8.45264 8.18018 8.30615 7.78711 8.01318 7.5332C7.7251 7.2793 7.271 7.15234 6.65088 7.15234H5.61816V10.3311ZM10.7451 8.63184C10.7451 9.78418 10.3838 10.6655 9.66113 11.2759C8.94336 11.8862 7.92041 12.1914 6.59229 12.1914H5.61816V16H3.34766V5.29199H6.76807C8.06689 5.29199 9.05322 5.57275 9.72705 6.13428C10.4058 6.69092 10.7451 7.52344 10.7451 8.63184ZM17.1611 7.65771C17.4639 7.65771 17.7153 7.67969 17.9155 7.72363L17.7471 9.81836C17.5664 9.76953 17.3467 9.74512 17.0879 9.74512C16.375 9.74512 15.8184 9.92822 15.418 10.2944C15.0225 10.6606 14.8247 11.1733 14.8247 11.8325V16H12.5908V7.81152H14.2827L14.6123 9.18848H14.7222C14.9761 8.72949 15.3179 8.36084 15.7476 8.08252C16.1821 7.79932 16.6533 7.65771 17.1611 7.65771Z",
    fill: "#FF3225"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebtCollectionClaims);
export default __webpack_public_path__ + "static/media/debt-collection-claims.45ed17fbb1abbd35bcf59d5dd0c4774c.svg";
export { ForwardRef as ReactComponent };